/** Build a single option with count/badge from recordCounts. countKey = key in recordCounts; use countKeyAllFleet for allFleetHubAPIDetails.recordCounts. */
export function option(recordCounts, allFleetRecordCount, item) {
  const count = item.countKeyAllFleet
    ? typeof allFleetRecordCount === "number"
      ? allFleetRecordCount
      : 0
    : (recordCounts?.[item.countKey] ?? 0);
  return {
    ...item,
    recordCount: count,
    countBadge: item.countKey || item.countKeyAllFleet ? count > 0 : false,
  };
}

export function mapOptions(recordCounts, allFleetRecordCount, items) {
  return items.map((item) => option(recordCounts, allFleetRecordCount, item));
}
